import { Children, Fragment, isValidElement } from 'react';
/**
 * React `Children.toArray` with validity check.
 *
 * @param children Children of element.
 * @param includeInvalid Includes invalid elements.
 * @returns Array of children.
 */
export const childrenArray = (children = [], includeInvalid = false) =>
  Children.toArray(children)
    .filter(child => includeInvalid || isValidElement(child))
    .flatMap(child =>
      typeof child !== 'string' && child.type === Fragment
        ? childrenArray(child.props.children, includeInvalid)
        : child
    );
export default childrenArray;
